<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">市场管理</Breadcrumb-item>
        <Breadcrumb-item>渠道管理</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div>
      <Form :label-width="100" :show-message="false" label-position="left">
        <Row :gutter="32">
          <Col :xs="11" :sm="6" :md="5">
            <Form-item :label-width="60" label="渠道名称">
              <Input v-model="queryParams.channelName" placeholder="请输入渠道名称"></Input>
            </Form-item>
          </Col>
          <Col :xs="11" :sm="6" :md="5">
            <Form-item :label-width="60" label="获客终端">
              <Col>
                <Select v-model="queryParams.channelType" clearable>
                  <Option value="MOBILE" key="1">手机端</Option>
                  <Option value="PC" key="2">PC端</Option>
                </Select>
              </Col>
            </Form-item>
          </Col>
          <Col :xs="11" :sm="6" :md="5">
            <Form-item :label-width="60" label="渠道分类">
              <Col>
                <Select v-model="queryParams.type" clearable>
                  <Option v-for="item in this.$constant.channelTypeEnum" :value="item.id" :key="item.id">{{ item.text }}</Option>
                </Select>
              </Col>
            </Form-item>
          </Col>
          <Col :xs="11" :sm="6" :md="5">
            <Form-item :label-width="60" label="市场分类">
              <Select v-model="queryParams.marketCategory" clearable>
                <Option value="__NONE__">未分类</Option>
                <Option v-for="name in marketCategoryNames" :value="name" :key="name">{{ name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="11" :sm="6" :md="5">
            <Form-item :label-width="40" label="状态">
              <Select v-model="queryParams.status" clearable>
                <Option value="0" key="1">禁用</Option>
                <Option value="1" key="2">启用</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="11" :sm="6" :md="5">
            <Form-item :label-width="40" label="来源">
              <Select v-model="queryParams.tchChannel" clearable>
                <Option v-for="item in $constant.tchChannel" :value="item.code" :key="item.code">
                  {{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="11" :sm="6" :md="5">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">
              搜索
            </Button>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" @click="toshowAddChannelModal">
            新建市场渠道
          </Button>
          <!-- <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button> -->
        </Row>
      </Form>
    </div>
    <List ref="channelList" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/channel/page"
          :params="queryParams" :onLoading="onLoading" :reload="reload" @on-selection-change="selectionChange"></List>

    <CreateChannelModal v-model="showAddChannelModal" @on-close="closeModal" :uid="uid"
                        :successCallback="search"></CreateChannelModal>

    <Modal title="编辑渠道" v-model="showUpdateChannelModal">
      <Form class="form" ref="updateChannelForm" :rules="channelRules" :model="updateChannelParams">
        <Row>
          <FormItem :label-width="90" label="渠道名称：" prop='channelName'>
            <Input v-model="updateChannelParams.channelName" placeholder="请输入渠道名称"></Input>
          </FormItem>
          <FormItem :label-width="90" label="渠道分类：" prop='channelType'>
            <Select v-model="updateChannelParams.channelType" clearable>
              <Option value="MOBILE" key="1">手机端</Option>
              <Option value="PC" key="2">PC端</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="90" label="渠道参数：" prop='channelParam'>
            <Input v-model="updateChannelParams.channelParam" placeholder="请输入渠道参数"></Input>
          </FormItem>
          <FormItem :label-width="90" label="渠道状态：" prop='status'>
            <Select v-model="updateChannelParams.status" clearable>
              <Option value='no' key="1">禁用</Option>
              <Option value='yes' key="2">启用</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="90" label="来源：" prop='tchChannel'>
            <Select v-model="updateChannelParams.tchChannel">
              <Option v-for="item in $constant.tchChannel" :value="item.code" :key="item.code">
                {{ item.text }}
              </Option>
            </Select>
          </FormItem>
          <FormItem :label-width="90" label="渠道描述：">
            <Input v-model="updateChannelParams.description" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                   placeholder="请输入渠道描述"/>
          </FormItem>
          <Form-item :label-width="90" label="市场专员">
            <AdminUserMultSelect :status="1" :groupTitles="['市场运营', '市场专员', '代理']" v-model="updateChannelParams.adminUserIds"></AdminUserMultSelect>
          </Form-item>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showUpdateChannelModal = false">取消</Button>
        <Button type="primary" size="large" :loading="loadingAddActivity" @click="updateChannel">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import CreateChannelModal from '@/components/market/modal/CreateChannelModal'
import AdminUserMultSelect from '../common/AdminUserMultSelect'

export default {
  components: {
    AdminUserMultSelect,
    CreateChannelModal
  },
  data () {
    let $constant = this.$constant
    return {
      selectDefaultImages: [],
      selectionUser: [],
      reload: 0,
      searchLoading: false,
      onLoading: false,
      loadingAddActivity: false,
      showAddChannelModal: false,
      showUpdateChannelModal: false,
      createChannelParams: {
        id: 0,
        channelName: '',
        channelType: '',
        channelParam: '',
        status: '',
        description: '',
        createTime: '',
        updateTime: '',
        adminUserIds: [],
      },
      updateChannelParams: {
        id: 0,
        channelName: '',
        channelType: '',
        channelParam: '',
        status: '',
        tchChannel: '',
        description: '',
        createTime: '',
        updateTime: '',
        adminUserIds: [],
      },
      marketCategoryNames: [],
      queryParams: {
        channelName: '',
        channelType: '',
        status: '',
        tchChannel: '',
        marketCategory: ''
      },
      channelRules: {
        channelName: [
          {type: 'string', required: true, message: '请输入渠道名称', trigger: 'blur'}
        ],
        channelType: [
          {type: 'string', required: true, message: '请输入渠道分类', trigger: 'blur'}
        ],
        channelParam: [
          {type: 'string', required: true, message: '请输入渠道参数', trigger: 'blur'}
        ],
        status: [
          {type: 'integer', required: true, message: '请选择渠道状态', trigger: 'blur'}
        ]
      },
      tableColumns: [
        {
          title: '渠道ID',
          // width: 80,
          align: 'center',
          key: 'id'
        },
        {
          title: '渠道名称',
          // width: 150,
          align: 'center',
          key: 'channelName'
        },
        {
          title: '渠道分类',
          align: 'center',
          key: 'type',
          render: (h, params) => {
            const row = params.row
            return h('div', [
              h('Select', {
                props: {
                  value: row.type,
                  transfer: true,
                  placement: 'top'
                },
                on: {
                  'on-change': (value) => {
                    this.updateChannelType(row.id, value)
                  }
                }
              }, [
                h('Option', {props: {value: ''}}, '请选择'),
                ...this.$constant.channelTypeEnum.map(item =>
                  h('Option', {props: {value: item.id}}, item.text)
                )
              ])
            ])
          }
        },
        {
          title: '市场分类',
          width: 160,
          align: 'center',
          render: (h, params) => {
            const row = params.row
            return h('Input', {
              props: {
                value: row.marketCategory || '',
                size: 'small',
                placeholder: '未分类'
              },
              on: {
                'on-blur': (event) => {
                  this.saveMarketCategory(row, event)
                }
              }
            })
          }
        },
        {
          title: '获客终端',
          // width: 120,
          align: 'center',
          key: 'channelType',
          render: (h, params) => {
            let row = params.row
            let text = row.channelType === 'MOBILE' ? '手机端' : 'PC端'
            return h('span', text)
          }
        },
        {
          title: '渠道参数',
          // width: 120,
          align: 'center',
          key: 'channelParam'
        },
        {
          title: '状态',
          // width: 120,
          align: 'center',
          key: 'status',
          render: (h, params) => {
            let row = params.row
            let text = row.status === 1 ? '启用' : '禁用'
            return h('span', text)
          }
        },
        {
          title: '来源',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let tchChannel = params.row.tchChannel
            let tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel)
            return h('div', tchChannelEnum && tchChannelEnum.text)
          }
        },
        {
          title: '渠道描述',
          // width: 250,
          align: 'center',
          key: 'description'
        },
        {
          title: '创建时间',
          // width: 180,
          align: 'center',
          key: 'createTime'
        },
        {
          title: '操作',
          // width: 130,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h('a', {on: {click: () => this.showUpdate(row)}}, '编辑'),
            ])
          }

        }
      ]
    }
  },
  mounted: function () {
  },
  created: function () {
    this.loadMarketCategories()
  },
  methods: {
    loadMarketCategories () {
      const self = this
      self.$http.get('/channel/marketCategories').then(res => {
        if (!res || res.status !== 'ok') {
          return
        }
        const data = res.data
        self.marketCategoryNames = Array.isArray(data) ? data : []
      }).catch(err => {
        console.log(err)
      })
    },
    saveMarketCategory (row, event) {
      const raw = event && event.target ? event.target.value : ''
      const next = raw == null ? '' : String(raw).trim()
      const prev = row.marketCategory == null ? '' : String(row.marketCategory).trim()
      if (next.length > 64) {
        this.$message.warning('市场分类不能超过 64 个字')
        return
      }
      if (next === prev) {
        return
      }
      const self = this
      const isNewName = next && self.marketCategoryNames.indexOf(next) === -1
      self.$http.post('/channel/updateMarketCategory', {
        id: row.id,
        marketCategory: next
      }).then(res => {
        if (res.status === 'ok') {
          self.$message.success('修改成功')
          self.$set(row, 'marketCategory', next)
          const list = self.$refs.channelList
          if (list && list.tableData) {
            const target = list.tableData.find(item => item.id === row.id)
            if (target && target !== row) {
              self.$set(target, 'marketCategory', next)
            }
          }
          if (isNewName) {
            self.loadMarketCategories()
          }
        }
      }).catch(err => {
        self.$message.error(err)
      })
    },
    toshowAddChannelModal () {
      let self = this
      self.showAddChannelModal = true
    },
    showUpdate (row) {
      let self = this
      self.updateChannelParams.id = row.id
      self.updateChannelParams.channelName = row.channelName
      self.updateChannelParams.channelType = row.channelType
      self.updateChannelParams.channelParam = row.channelParam
      self.updateChannelParams.status = row.status == 1 ? 'yes' : 'no'
      self.updateChannelParams.description = row.description
      self.updateChannelParams.createTime = row.createTime
      self.updateChannelParams.updateTime = row.updateTime
      self.updateChannelParams.tchChannel = row.tchChannel
      self.updateChannelParams.adminUserIds = row.adminUserIds
      self.showUpdateChannelModal = true
    },
    updateChannel () {
      let self = this
      self.updateChannelParams.status = self.updateChannelParams.status == 'yes' ? 1 : 0
      self.$refs.updateChannelForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingAddActivity = false
          return
        }
        self.$http.post('/channel/update', self.updateChannelParams).then(res => {
          if (res.status === 'ok') {
            self.showUpdateChannelModal = false
            self.$message.success('修改成功')
            self.search()
          }
        }).catch(err => {
          console.log(`err`, err)
          self.$message.error(err)
        })
      })
    },
    updateChannelType (id, type) {
      let self = this
      self.$http.post('/channel/updateChannelType', {id: id, type: type}).then(res => {
        if (res.status === 'ok') {
          self.$message.success('修改成功')
        }
      }).catch(err => {
        self.$message.error(err)
      })
    },
    search () {
      this.selectionUser = []
      this.reload = new Date().getTime()
    },
    selectionChange (selection) {
      this.selectionUser = selection
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ChannelManagement.vue?e37e1c88